import { all } from "redux-saga/effects";

import {
    //getApiRoutesWatcher,
    //getApiRoutesSuccessWatcher
} from "./getApiRoutes.saga";

import { initializeWatcher } from "./initialize.saga";

export default function* rootSaga() {
    yield all([
        //getApiRoutesWatcher(),
        //getApiRoutesSuccessWatcher(),
        initializeWatcher()
    ]);
}
